import { render, staticRenderFns } from "./SummaryScreen.vue?vue&type=template&id=c4defa86&scoped=true&"
import script from "./SummaryScreen.vue?vue&type=script&lang=js&"
export * from "./SummaryScreen.vue?vue&type=script&lang=js&"
import style0 from "./SummaryScreen.vue?vue&type=style&index=0&id=c4defa86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4defa86",
  null
  
)

export default component.exports